<style lang="less" scoped></style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" label-width="120px" class="detail-form">
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="充电桩型号名称" prop="pileTypeName">
                <el-input v-model="detailForm.pileTypeName" size="small"></el-input>
              </el-form-item>
              <el-form-item label="规格型号" prop="specificationName">
                <el-input v-model="detailForm.specificationName" size="small"></el-input>
              </el-form-item>
              <el-form-item label="成品料号" prop="materialNo">
                <el-input v-model="detailForm.materialNo" size="small"></el-input>
              </el-form-item>
              <el-form-item label="充电速度" prop="chargingSpeed">
                <el-select class="full-width" v-model="detailForm.chargingSpeed" size="small" clearable @change="handleChangeFirst($event)">
                  <el-option v-for="item in chargingSpeed" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电流输出类型" prop="currentOutType">
                <el-select class="full-width" v-model="detailForm.currentOutType" size="small" clearable @change="handleChangeSecond($event)">
                  <el-option v-for="item in chargingType" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接口类型" prop="interfaceType">
                <el-select class="full-width" v-model="detailForm.interfaceType" size="small" clearable @change="handleChangeThird($event)">
                  <el-option v-for="item in interfaceType" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="额定电压(V)" prop="ratedVoltage">
                <el-input v-model="detailForm.ratedVoltage" size="small"></el-input>
              </el-form-item>
              <el-form-item label="额定功率" prop="ratedPower">
                <el-input v-model="detailForm.ratedPower" size="small"></el-input>
              </el-form-item>
              <el-form-item label="蓝牙功能" prop="bluetoothFlag">
                <el-select class="full-width" v-model="detailForm.bluetoothFlag" size="small" clearable>
                  <el-option label="有" value="Y"></el-option>
                  <el-option label="无" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="蓝牙配置" prop="bluetoothPairFlag">
                <el-select class="full-width" v-model="detailForm.bluetoothPairFlag" size="small" clearable>
                  <el-option label="可配对" value="N"></el-option>
                  <el-option label="不带配对" value="Y"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="业务归属" prop="businessBelong">
                <el-select class="full-width" v-model="detailForm.businessBelong" size="small" clearable @change="handleChangeFourth($event)">
                  <el-option v-for="item in businessBelongList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="系统状态" prop="useState">
                <el-select class="full-width" v-model="detailForm.useState" size="small" clearable @change="handleChangeFifth($event)">
                  <el-option v-for="item in useStateList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="保质有效期" prop="warrantyTimeStatus">
                <el-select class="full-width" v-model="detailForm.warrantyTimeStatus" size="small" clearable @change="handleChangeSixth($event)">
                  <el-option v-for="item in warrantyTimeList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联网订阅有效期" prop="networkTimeStatus">
                <el-select class="full-width" v-model="detailForm.networkTimeStatus" size="small" clearable @change="handleChangeSeven($event)">
                  <el-option v-for="item in networkTimeList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item label="型号" prop="pileTypeCode">
                <el-input v-model="detailForm.pileTypeCode" size="small"></el-input>
              </el-form-item>
              <el-form-item label="充电桩显示名称" prop="showName">
                <el-input v-model="detailForm.showName" size="small"></el-input>
              </el-form-item>
              <el-form-item label="存货大类名称" prop="bigName">
                <el-input v-model="detailForm.bigName" size="small"></el-input>
              </el-form-item>
              <el-form-item label="充电枪数量" prop="gunNum">
                <el-input v-model="detailForm.gunNum" size="small"></el-input>
              </el-form-item>
              <el-form-item label="额定电流(A)" prop="ratedCurrent">
                <el-input v-model="detailForm.ratedCurrent" size="small"></el-input>
              </el-form-item>
              <el-form-item label="单项桩/三相桩" prop="phaseType">
                <el-select class="full-width" v-model="detailForm.phaseType" size="small" clearable @change="handleChangeEighth($event)">
                  <el-option v-for="item in phaseList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="即插即充" prop="offHandChargingFlag">
                <el-select class="full-width" v-model="detailForm.offHandChargingFlag" size="small" clearable>
                  <el-option label="支持" value="Y"></el-option>
                  <el-option label="不支持" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="无感充电" prop="cardFlag">
                <el-select class="full-width" v-model="detailForm.cardFlag" size="small" clearable>
                  <el-option label="支持" value="Y"></el-option>
                  <el-option label="不支持" value="N"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="蓝牙协议" prop="bluetoothVersion">
                <el-input v-model="detailForm.bluetoothVersion" size="small"></el-input>
              </el-form-item>
              <el-form-item label="音频" prop="audioType">
                <el-select class="full-width" v-model="detailForm.audioType" size="small" clearable @change="handleChangeNinth($event)">
                  <el-option v-for="item in audioFrequencyList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联网方式" prop="networkStatus">
                <el-select class="full-width" v-model="detailForm.networkStatus" size="small" clearable @change="handleChangeTenth($event)">
                  <el-option v-for="item in networkList" :key="item.id" :label="item.configName"
                             :value="item.configVal"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="充电桩图片">
                <el-upload :class="{ hide: hideUpload }" action="" :http-request="toUploadImg" list-type="picture-card"
                        :before-upload="beforeAvatarUpload" :show-file-list="false">
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width: 146px; height: 146px;">
                  <i v-else class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    (只能上传一张图片,且不得超过1MB!)
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
  import pageConfig from './page-config'
  export default {
    data() {
      return {
        pageConfig,
        editFlag: false,
        pageTitle: '充电桩型号新增',
        // 默认值设置
        detailForm: {},
        hideUpload: false,//上传图片按钮
        imageUrl: "",//图片储存
        dialogImageUrl: null,//图片地址
        dialogVisible: false,

        chargingSpeed: [], // 充电速度
        chargingType: [], // 电流输出类型
        interfaceType: [], // 接口类型
        businessBelongList: [], // 业务归属
        useStateList: [], // 系统状态
        warrantyTimeList: [], // 质保有效期
        networkTimeList: [], // 联网订阅
        phaseList: [], // 单相桩、三相桩
        audioFrequencyList: [], // 音频
        networkList: [], // 联网方式

      }
    },
    created() {
      this.init()
    },
    methods: {

      //判断是否为编辑模式
      init() {
        let _ = this;
        // 电流输出类型
        _.$H.post(_, _.$A.config.list, { configType: '100' }).then((res) => {
          _.chargingType = res.data.data;
        })
        // 充电速度
        _.$H.post(_, _.$A.config.list, { configType: '101' }).then((res) => {
          _.chargingSpeed = res.data.data;
        })
        // 接口类型
        _.$H.post(_, _.$A.config.list, { configType: '102' }).then((res) => {
          _.interfaceType = res.data.data;
        })
        // 单相桩、三相桩
        _.$H.post(_, _.$A.config.list, { configType: '229' }).then((res) => {
          _.phaseList = res.data.data;
        })
        // 音频
        _.$H.post(_, _.$A.config.list, { configType: '300' }).then((res) => {
          _.audioFrequencyList = res.data.data;
        })
        // 业务归属
        _.$H.post(_, _.$A.config.list, { configType: '301' }).then((res) => {
          _.businessBelongList = res.data.data;
        })
        // 联网方式
        _.$H.post(_, _.$A.config.list, { configType: '201' }).then((res) => {
          _.networkList = res.data.data;
        })
        // 质保有效期
        _.$H.post(_, _.$A.config.list, { configType: '302' }).then((res) => {
          _.warrantyTimeList = res.data.data;
        })
        // 联网订阅
        _.$H.post(_, _.$A.config.list, { configType: '303' }).then((res) => {
          _.networkTimeList = res.data.data;
        })
        // 使用状态（系统使用）
        _.$H.post(_, _.$A.config.list, { configType: '149' }).then((res) => {
          _.useStateList = res.data.data;
        })
        if (_.$store.state.editId) {
          _.editFlag = true;
          _.pageTitle = '充电桩型号编辑';
          _.getFormInfo();
        }
        // else {
        //   // 新增 初始化 默认选中
        //   _.detailForm = {
        //     bluetoothFlag: 'Y',
        //     offHandChargingFlag: 'Y',
        //     bluetoothPairFlag: 'Y',
        //     cardFlag: 'Y',
        //     audioFrequencyFlag: '01',
        //     networkStatus: '01',
        //     businessBelong: '01',
        //     warrantyTimeStatus: '02',
        //     networkTimeStatus: '10',
        //     useState: '01',
        //   }
        // }
      },
      //上传图片
      toUploadImg(item) {
        let _ = this;
        let fd = new FormData();
        fd.append('file', item.file)
        _.$H.postFormData(_, _.$A.digitization.pileFunctionImgUpload, fd).then(res => {
          if(res.data.status === 200){
            _.imageUrl = res.data.data.viewPath || '';
            _.$U.success("图片上传成功！")
          }
        })
      },

      // 获取充电桩详情信息
      getFormInfo() {
        let _ = this;
        let param = {
          pileTypeNo: _.$store.state.editId
        }
        _.$H.post(_, _.$A.digitization.findPileFunctionByNo, param).then(res => {
          _.detailForm = res.data.data;
          // _.detailForm = {
          //
          // }
          _.imageUrl = _.detailForm.pileImgUrl;
        })
      },

      // 表单提交
      submitForm(formName) {
        let _ = this
        _.detailForm.corpNo = _.$store.state.corpNo;
        _.detailForm.pileImgUrl = _.imageUrl;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(_.editFlag){
              _.$H.post(_, _.$A.digitization.pileFunctionEdit, _.detailForm).then(res => {
                if(res.status === 200){
                  _.$router.push({
                    name: pageConfig.listRouter
                  });
                }
              })
            }else {
              _.$H.post(_, _.$A.digitization.pileFunctionAdd, _.detailForm).then(res => {
                if(res.status === 200){
                  _.$router.push({
                    name: pageConfig.listRouter
                  });
                }
              })
            }
          }
        })
      },

      // 取消
      resetForm() {
        this.$router.push({
          name: pageConfig.listRouter,
        })
      },

      // 图片大小限制
      beforeAvatarUpload(file) {
        const isLt200K = file.size / 1024 / 1024 < 1
        if (!isLt200K) {
          this.$U.error('上传广告图片大小不能超过 1MB!')
        }
        return isLt200K
      },

      // 充电速度
      handleChangeFirst(val){
        let _ = this;
        _.chargingSpeed.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.chargingSpeedName = li.configName
          }
        })
      },
      // 电流输出类型
      handleChangeSecond(val){
        let _ = this;
        _.chargingType.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.currentOutTypeName = li.configName
          }
        })
      },
      // 接口类型
      handleChangeThird(val){
        let _ = this;
        _.interfaceType.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.interfaceTypeName = li.configName
          }
        })
      },
      // 业务归属
      handleChangeFourth(val){
        let _ = this;
        _.businessBelongList.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.businessBelongName = li.configName
          }
        })
      },
      // 系统状态
      handleChangeFifth(val){
        let _ = this;
        _.useStateList.forEach(li => {
          if(val === li.configVal){
            _.detailForm.useStateName = li.configName;
          }
        })
      },
      // 保质有效期
      handleChangeSixth(val){
        let _ = this;
        _.warrantyTimeList.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.warrantyTimeStatusName = li.configName
          }
        })
      },
      // 联网订阅有效期
      handleChangeSeven(){
        let _ = this;
        _.networkTimeList.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.networkTimeStatusName = li.configName
          }
        })
      },
      // 单项桩/三相桩
      handleChangeEighth(val){
        let _ = this;
        _.phaseList.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.phaseTypeName = li.configName
          }
        })
      },
      // 音频
      handleChangeNinth(val){
        let _ = this;
        _.audioFrequencyList.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.audioTypeName = li.configName
          }
        })
      },
      // 联网方式
      handleChangeTenth(val){
        let _ = this;
        _.networkList.forEach(li => {
          if(val === li.configVal){
            return _.detailForm.networkStatusName = li.configName
          }
        })
      },

    },

  }
</script>
